import { render, staticRenderFns } from "./AppMultipleFile.vue?vue&type=template&id=be45df00&scoped=true&"
import script from "./AppMultipleFile.vue?vue&type=script&lang=js&"
export * from "./AppMultipleFile.vue?vue&type=script&lang=js&"
import style0 from "./AppMultipleFile.vue?vue&type=style&index=0&id=be45df00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be45df00",
  null
  
)

export default component.exports